export default {
  playlist: {},
  playlists_videos: [],
}
